export const answerFeedbackWhenChangingProgram = {
  NOT_RELEVANT : 'NOT_RELEVANT',
  TOO_DIFFICULT : 'TOO_DIFFICULT',
  NO_PROGRESS : 'NO_PROGRESS',
  NEED_MORE_GUIDANCE : 'NEED_MORE_GUIDANCE',
  BAD_FORMAT : 'BAD_FORMAT',
  OTHER : 'OTHER'
};